"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  data: function data() {
    return {
      /* 表格设置参数 */
      table: {
        border: true,
        stripe: true,
        indent: 8,
        'highlight-current-row': true,
        'tree-props': {
          children: 'children',
          hasChildren: 'hasChildren'
        },
        // data                   : new Array(20).fill(0).map((item, index) => ({ id: index }))
        data: [],
        style: {
          width: ' 100%',
          height: '100%',
          overflow: 'auto'
        },
        height: '1'
      },
      /* 列表头设置参数 */
      columnOption: {
        columns: {
          'show-overflow-tooltip': true
        },
        index: {
          width: 50,
          label: '序号',
          fixed: 'left'
        },
        selection: {
          width: 40,
          fixed: 'left'
        },
        rowOperations: {
          fixed: 'right',
          label: '操作'
        }
      }
    };
  },
  computed: {
    /** 表格绑定数据
     * @return { Object } 表格 参数
     */
    getTableOptions: function getTableOptions() {
      return this.$$deepMerge(this.table, this.$attrs, this.tableOptions);
    },
    /** 表格表单绑定数据
     * @return { Object } 表格 参数
     */
    getTableFormOptions: function getTableFormOptions() {
      var border = this.getTableOptions.border;
      var options = this.$$deepMerge({
        is: this.isForm !== false && this.isFormSwaraj !== false ? 'el-form' : 'div',
        'inline-message': true,
        style: "".concat(border === '' || border === true ? ';border: 1px solid #dfe6ec;' : '')
      }, this.tableFormOptions);
      if (this.isForm) {
        var _options$model;
        (_options$model = options.model) !== null && _options$model !== void 0 ? _options$model : options.model = this.table;
      }
      return this.$$deepMerge(this.tableFormOptions, options);
    },
    /** 列参数设置
     * @return { Boolean } 列 参数
     */
    getColumnOptions: function getColumnOptions() {
      return this.$$deepMerge(this.columnOption.columns, this.columnOptions);
    },
    /** 序号列 参数设置
     * @return { Boolean } 序号列 参数
     */
    getIndexOptions: function getIndexOptions() {
      return this.$$deepMerge(this.columnOption.index, this.columnOptions, this.columnIndexOptions);
    },
    /** 序号列 参数设置
     * @return { Boolean } 序号列 参数
     */
    getSelectionOptions: function getSelectionOptions() {
      var a = this.$$deepMerge(this.columnOption.selection, this.columnOptions, this.columnSelectionOptions);
      if (!this.isSingle) a.type = 'selection';else delete a.type;
      return a;
    },
    /** 操作列 参数设置
     * @return { Boolean } 操作列 参数
     */
    getOperationsOptions: function getOperationsOptions() {
      var a = this.$$deepMerge(this.columnOption.rowOperations, this.columnOptions, this.columnOperationsOptions);
      return a;
    }
  },
  methods: {
    getTableFormItemsOptions: function getTableFormItemsOptions(item) {}
  }
};